module.exports = __webpack_public_path__ + "static/media/ml.bdf5f3c6.png";